import React from "react"
import "./src/styles/reset.css"
import "./src/styles/global.css"
import ThemeProvider from "./src/context/ThemeContext"

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
)

// trigger an immediate page refresh when an update is found
export const onServiceWorkerUpdateReady = () => window.location.reload()

// Reset scroll to top on navigation; restore saved position on back/forward.
export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  const savedPosition = getSavedScrollPosition(location)
  if (savedPosition) {
    window.scrollTo(...savedPosition)
  } else {
    window.scrollTo(0, 0)
  }
  // Ensure any scroll-listening hooks (e.g. the header's useScroll) reset
  // their state — scrollTo doesn't always fire a scroll event when going to 0.
  window.dispatchEvent(new Event("scroll"))
  return false
}
